import * as types from './types';

const initialState: types.ToastState = {
  list: [],
  autoDeleteTime: 10000,
};

type ToastAction =
  | { type: typeof types.ADD_TOAST; payload: types.Toast }
  | { type: typeof types.REMOVE_TOAST; payload: number };

export default function toastsReducer(state = initialState, action: ToastAction): types.ToastState {
  switch (action.type) {
    case types.ADD_TOAST:
      return { ...state, list: [...state.list, action.payload] };
    case types.REMOVE_TOAST:
      return { ...state, list: state.list.filter((item) => item.id !== action.payload) };
    default:
      return state;
  }
}
